__turbopack_context__.v({
  "app_light_theme": "gifts-catalog-modal-module-scss-module__IYV9Aq__app_light_theme",
  "gifts": "gifts-catalog-modal-module-scss-module__IYV9Aq__gifts",
  "gifts__grid": "gifts-catalog-modal-module-scss-module__IYV9Aq__gifts__grid",
  "gifts__gridWrapper": "gifts-catalog-modal-module-scss-module__IYV9Aq__gifts__gridWrapper",
  "gifts__heading": "gifts-catalog-modal-module-scss-module__IYV9Aq__gifts__heading",
});
